import React from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './Home';
import GenerateReport from './GenerateReport';

const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/genrate-report" element={<GenerateReport />} />
        </Routes>
      </Router>
    </>
  )
}

export default App